import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TheCrypt} from "../TheCrypt";

export class TheCryptIdleNormalPresentation implements FlowStatePresentation {
    constructor() {

    }

    public start(flowStateController:FlowStateController) {

        if(!TheCrypt.autoPlayPlugin.isAutoplayRound) {
            TheCrypt.reelFrame.startIdle();
        }
        this.onComplete(flowStateController);
    }

    private onComplete(flowStateController: FlowStateController): void {
        flowStateController.finish();
    }

    private skip(flowStateController:FlowStateController) {
        this.onComplete(flowStateController)
    }
}